import { C } from "./MockupParts";

export const SINGLE_PAGES = [
  { group: "Diagnóstico rápido · Talent Health Check", items: [
    ["thc-1", "Portada"], ["thc-2", "Puntuación global"], ["thc-3", "Gráfico por área"],
    ["thc-4", "Diagnóstico por dimensión"], ["thc-5", "Plan de acción sugerido"]] },
  { group: "Team Readiness Report · documento para inversores", items: [
    ["tr-1", "Portada"], ["tr-2", "Resumen ejecutivo y metodología"], ["tr-3", "Mapa de riesgo"],
    ["tr-4", "Lectura por áreas"], ["tr-5", "Anexo: plan de acción"]] },
  { group: "Consultoría premium · informe", items: [
    ["cr-1", "Portada"], ["cr-2", "Resumen ejecutivo"], ["cr-3", "Área A · Marca empleadora"],
    ["cr-4", "Área B · Selección"], ["cr-5", "Entregables finales"]] },
  { group: "Consultoría premium · checklist de acciones", items: [["cl-1", "Checklist · página 1"], ["cl-2", "Checklist · página 2"]] },
  { group: "Consultoría premium · herramientas IA", items: [
    ["tool-1", "Oferta de empleo"], ["tool-2", "Guía de entrevista"], ["tool-3", "Plan de onboarding"]] },
  { group: "Consultoría premium · contraste de percepciones", items: [["perc-1", "Contraste CEO vs. equipo"]] },
];

const PAGE_W = 740;

export const SinglePageMockup = ({ id, index, innerRef }) => {
  const rot = index % 2 === 0 ? -2.2 : 2.2;
  const h = Math.round(PAGE_W * 1.4142);
  const top = Math.round((1350 - h) / 2) - 10;
  return (
    <div
      ref={innerRef}
      className="relative overflow-hidden"
      style={{ width: 1080, height: 1350, background: `radial-gradient(110% 80% at 50% 45%, #FFFFFF 0%, ${C.ivory} 70%)` }}
    >
      <div
        className="absolute"
        style={{
          left: (1080 - PAGE_W * 0.86) / 2, width: PAGE_W * 0.86, top: top + h - 24, height: 48,
          background: "radial-gradient(50% 50% at 50% 50%, rgba(8,80,65,.32) 0%, rgba(8,80,65,0) 100%)",
          filter: "blur(10px)", transform: `rotate(${rot}deg)`,
        }}
      />
      <div
        className="absolute bg-white"
        style={{
          left: (1080 - PAGE_W) / 2, top, width: PAGE_W, height: h, transform: `rotate(${rot}deg)`,
          boxShadow: "0 1px 2px rgba(8,80,65,.08), 0 14px 28px -18px rgba(8,80,65,.35)", borderRadius: 3, overflow: "hidden",
        }}
      >
        <img src={`/mockups/single/${id}.png`} alt="" className="block w-full h-full" style={{ objectFit: "cover" }} draggable={false} />
        <span
          className="absolute"
          style={{
            right: 12, top: 12, fontFamily: "Inter, sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: ".1em",
            textTransform: "uppercase", color: "#94A3B8", background: "rgba(255,255,255,.92)", border: "1px solid #EEF2F6",
            padding: "2px 9px", borderRadius: 999,
          }}
        >
          Ejemplo
        </span>
      </div>
    </div>
  );
};
